export default function () {
	const getTCPATrustedFormToken = () => {
		const tokenElement = $('#nrfTrustedFormToken_0');
		const tokenValue = tokenElement.val();
		return tokenValue ? String(tokenValue) : null;
	};

	const loadTCPATrustedForm = () => {
		try {
			// Check if the script is already loaded
			if (document.querySelector('script[src*="trustedform.com"]')) {
				return false;
			}

			// Ensure a form element exists for TrustedForm
			if (typeof document.forms[0] === 'undefined') {
				const newForm = document.createElement('form');
				newForm.setAttribute('id', '__tform');
				document.body.appendChild(newForm);
			}

			// Construct the TrustedForm script URL
			const trustedFormUrl = new URL(
				`${
					document.location.protocol === 'https:' ? 'https' : 'http'
				}://api.trustedform.com/trustedform.js`,
			);

			trustedFormUrl.searchParams.append('token_field', 'nrfTrustedFormToken');
			trustedFormUrl.searchParams.append('field', 'nrfTrustedFormCertUrl');
			trustedFormUrl.searchParams.append('ping_field', 'nrfTrustedFormPingUrl');
			trustedFormUrl.searchParams.append('l', `${new Date().getTime() + Math.random()}`);
			trustedFormUrl.searchParams.append('use_tagged_consent', 'true');

			if (window.Bark.ENV.web_hostname !== 'www.bark.com') {
				trustedFormUrl.searchParams.append('sandbox', 'true');
			}

			const tfScript = document.createElement('script');
			tfScript.type = 'text/javascript';
			tfScript.async = true;
			tfScript.src = trustedFormUrl.href;
			tfScript.onerror = (e) => {
				console.error('TrustedForm script load failed.', e);
			};

			// Inject the script into the document
			const firstScript = document.getElementsByTagName('script')[0];
			const headNode = firstScript.parentNode;
			if (headNode) {
				headNode.insertBefore(tfScript, firstScript);
			}

			return true;
		} catch (e) {
			console.error(e);
		}
		return false;
	};

	const consentToTCPA = (hashedProjectId, hashedSellerIds) => {
		return window.Bark.api(
			`/${hashedProjectId}/tcpa-consent-given`,
			{
				spidhs: hashedSellerIds,
			},
			() => {},
			() => {},
			'POST',
		);
	};

	const setProjectCertificate = (projectId, hashedSellerIds, trustedFormToken) => {
		return window.Bark.api(
			`/buyer/project/${projectId}/certificate`,
			{
				spidhs: hashedSellerIds,
				trustedFormToken,
			},
			() => {},
			() => {},
			'POST',
			window.Bark.apiVersionHeader('v2'),
		);
	};

	const grantConsent = (self, hashedProjectId) => {
		const token = getTCPATrustedFormToken();
		const sellerProfileId = self.data('sellerProfileId');
		consentToTCPA(hashedProjectId, [sellerProfileId]);
		setProjectCertificate(hashedProjectId, [sellerProfileId], token);
	};

	const revokeConsent = (self, hashedProjectId) => {
		let parent = self.parent();
		let sellerProfileId = parent.data('sellerProfileId');
		let sellerName = parent.data('companyName');
    const card = parent.closest('.seller-list-card');

    function toggleOptedOut() {
      card.find('.tcpa-opt-out').toggleClass('d-none');
    }
		if (window.BuyerApp) {
			window.BuyerApp.launchModule('tcpa-opt-out-modal', '__tcpa-opt-out-modal', {
				hashedProjectId,
				hashedSellerId: sellerProfileId,
				sellerName,
				onSuccess: () => {
					toggleOptedOut();
				},
			});
		}
	};

	return {
		getTCPATrustedFormToken,
		loadTCPATrustedForm,
		grantConsent,
		revokeConsent,
	};
}
